import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function cloneAbstractControl<T extends AbstractControl>(control: T): T {
  if (control instanceof FormGroup) {
    const group = new FormGroup({}, { validators: control.validator, asyncValidators: control.asyncValidator });
    Object.keys(control.controls).forEach(key => {
      group.addControl(key, cloneAbstractControl(control.controls[key]));
    });
    return group as unknown as T;
  }

  if (control instanceof FormArray) {
    const arr = new FormArray([]);
    control.controls.forEach(c => arr.push(cloneAbstractControl(c)));
    return arr as unknown as T;
  }

  if (control instanceof FormControl) {
    return new FormControl(control.value, control.validator, control.asyncValidator) as unknown as T;
  }

  throw new Error('Unsupported control type');
}

export function matchStrings(content: string, keyword: string) {
  const contentNormalised = content.trim().toLowerCase();
  const keywordNormalised = keyword.trim().toLowerCase();

  return contentNormalised.includes(keywordNormalised);
}

export class ExtraValidator {
  public static minArrayLength(min: number) {
    return (control: FormArray): ValidationErrors | null => {
      if (!control || !Array.isArray(control.controls)) {
        return null;
      }

      return control.controls.length >= min
        ? null
        : { minArrayLength: true };
    };
  }

  public static atLeastOneRequired(...fields: string[]): ValidatorFn {
    return (group) => {
      const hasValue = fields.some(field => {
        const control = group.get(field);

        return control && control.value != null && control.value !== '';
      });

      return hasValue ? null : { atLeastOneRequired: { fields } };
    };
  }

}